import { render, staticRenderFns } from "./ModifyStatus.vue?vue&type=template&id=56f229c8"
import script from "./ModifyStatus.vue?vue&type=script&lang=js"
export * from "./ModifyStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports